import { AsyncBuffer } from './AsyncBuffer.js';
import {
  deleteTimestamp,
  getNewSessionId,
  getSessionId,
  getViewBeansUrl,
  isLastRequestValid,
  saveTimestamp
} from './utils.js';

export function getInstance() {
  return new AHSessionService();
}

export class AHSessionService {

  constructor() {
    this.id = (new Date()).getTime();
    this.pendingPromises = new AsyncBuffer();
  }

  getSession() {
    const requestId = Math.floor(Math.random() * 100);
    console.log('--------->> Get Session - request', requestId);

    const isSessionValid = isLastRequestValid();
    const sessionId = getSessionId();

    if (sessionId && isSessionValid) {
      // Session is valid and last request is not expired
      // Save the timestamp
      saveTimestamp();
      // Resolve with the session ID
      console.log(requestId + '- resolve with sessionId', sessionId);
      return Promise.resolve(sessionId);
    } else {
      // session not exist or last request is expired
      if (!this.pendingPromises.isLocked()) {
        console.log(requestId + '- is not locked - lock it and start building session');
        // No session is building - start creation
        this.pendingPromises.lock();
        // Get a new session id
        getNewSessionId(getViewBeansUrl(sessionId))
          .then((sessionId) => {
            this.resolveAll(sessionId);
          }).catch((error) => {
            this.rejectAll(error);
          });
      } else {
        console.log(requestId + '- is locked - add to pending list');
      }
      // Create a promise, add it to the pending list and return it
      return this.pendingPromises.wait(requestId);
    }
  }

  resolveAll(sessionId) {
    console.log('--------## SessionService - resolve all with', sessionId);
    // Save timestamp of the request
    saveTimestamp();
    // Resolve all promises with the new session id
    this.pendingPromises.resolve(sessionId);
  }

  rejectAll(error) {
    console.log('--------## SessionService - reject all');
    // Clean timestamp of the request
    deleteTimestamp();
    // Reject all promises
    this.pendingPromises.reject(error);
  }

}

export const SessionService = getInstance();
